import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import Usuario from "../../page/usuarios/Usuario";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const UsuarioController = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [provincias, setProvincias] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [facturacion, setFacturacion] = useState(null);
  const [loading, setLoading] = useState(null);
  const [filePreview, setFilePreview] = useState({
    comprobante_afip: null,
    comprobante_cbu: null,
    comprobante_entidad: null,
    comprobante_identificador: null,
  });

  const handleFilePreview = (file, fieldName) => {
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFilePreview(prev => ({
          ...prev,
          [fieldName]: reader.result
        }));
      };
      reader.readAsDataURL(file);
    } else if (file && file.type === 'application/pdf') {
      // Para PDFs, mostramos un icono o texto indicativo
      setFilePreview(prev => ({
        ...prev,
        [fieldName]: 'pdf'
      }));
    } else if (file) {
      // Para otros tipos de archivo, mostramos el nombre
      setFilePreview(prev => ({
        ...prev,
        [fieldName]: file.name
      }));
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "aplicar":
        {
          let formData = new FormData();
          let formFacturacion = new FormData();
          formData.append("_method", "PUT");
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("direccion", usuario.direccion);
          formData.append("provincia", usuario.provincia);
          formData.append("localidad", usuario.localidad);

          // Datos de facturación
          if (facturacion) {
            formFacturacion.append("_method", "PUT");
            formFacturacion.append("entidad", facturacion.entidad || "");
            formFacturacion.append("cbu", facturacion.cbu || "");
            formFacturacion.append("dato_fiscal", facturacion.dato_fiscal || "");
            formFacturacion.append("porcentaje", facturacion.porcentaje || "");

            // Archivos de comprobantes
            if (filePreview.comprobante_afip) {
              formFacturacion.append("comprobante_afip", facturacion.comprobante_afip);
            }
            if (filePreview.comprobante_cbu) {
              formFacturacion.append("comprobante_cbu", facturacion.comprobante_cbu);
            }
            if (filePreview.comprobante_entidad) {
              formFacturacion.append("comprobante_entidad", facturacion.comprobante_entidad);
            }
          }

          if (usuario.password && usuario.repeat_password) {
            if (usuario.password !== usuario.repeat_password) {
              return Alerts({
                msg: "Alert",
                title: "La contraseña debe ser la misma",
                code: "200",
                type: "warning",
              });
            }
            formData.append("password", usuario.password);
            formData.append("repeat_password", usuario.repeat_password);
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios/${usuario.id}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {

            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });

            const responseFacturacion = await RestPrivateAntesala({
              url: `/usuario-facturacion/${facturacion.id}`,
              formData: formFacturacion,
              method: "post",
              setLoading: setLoading,
            });


            if (responseFacturacion.success == 201 || responseFacturacion.status == 200) {
              Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            } else {

            }
            //return navigate(`/dashboard/cupones/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "guardar":
        {
          let formData = new FormData();
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("direccion", usuario.direccion);
          formData.append("provincia", usuario.provincia);
          formData.append("localidad", usuario.localidad);

          // Datos de facturación
          if (facturacion) {
            formData.append("entidad", usuario.facturacion.entidad || "");
            formData.append("cbu", usuario.facturacion.cbu || "");
            formData.append("dato_fiscal", usuario.facturacion.dato_fiscal || "");
            formData.append("porcentaje", usuario.facturacion.porcentaje || "");

            // Archivos de comprobantes
            if (usuario.facturacion.comprobante_afip) {
              formData.append("facturacion_comprobante_afip", usuario.facturacion.comprobante_afip);
            }
            if (usuario.facturacion.comprobante_cbu) {
              formData.append("facturacion_comprobante_cbu", usuario.facturacion.comprobante_cbu);
            }
            if (usuario.facturacion.comprobante_entidad) {
              formData.append("facturacion_comprobante_entidad", usuario.facturacion.comprobante_entidad);
            }
          }

          if (usuario.password && usuario.repeat_password) {
            if (usuario.password !== usuario.repeat_password) {
              return Alerts({
                msg: "Alert",
                title: "La contraseña debe ser la misma",
                code: "200",
                type: "warning",
              });
            }
            formData.append("password", usuario.password);
            formData.append("repeat_password", usuario.repeat_password);
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios/${value}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
            return navigate(`/dashboard/usuarios/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      //case "rol":
      case "provincia":
      case "localidad":
      case "direccion":
      case "apellido":
      case "nombre":
        {
          setUsuario({
            ...usuario,
            [e.target.name]: e.target.value
          })
        }
        break;
      case "entidad":
      case "cbu":
      case "dato_fiscal":
      case "identificador":
      case "porcentaje":
      case "comprobante_afip":
      case "comprobante_cbu":
      case "comprobante_entidad":
      case "comprobante_identificador":
        {
          const fieldName = e.target.name;
          const value = e.target.type === 'file' ? e.target.files[0] : e.target.value;

          // Si es un archivo, generar previsualización
          if (e.target.type === 'file' && e.target.files[0]) {
            handleFilePreview(e.target.files[0], fieldName);
          }

          setFacturacion({
            ...facturacion,
            [fieldName]: value
          })
        }
        break;
    }
  };

  const fetchFilePreview = async (fileName, field) => {
    try {
      const response = await apiPrivateAntesala.get(`/usuario-facturacion/archivo/${fileName}`, {
        responseType: 'blob'
      });

      if (response.status === 200) {
        // Crear Object URL para vista previa en caché
        const objectUrl = URL.createObjectURL(response.data);

        setFilePreview(prev => ({
          ...prev,
          [field]: {
            url: objectUrl,
            fileName: fileName,
            isExisting: true,
            type: response.data.type,
            blob: response.data
          }
        }));
      }
    } catch (error) {
      console.error(`Error al cargar archivo ${fileName}:`, error);
    }
  };

  const fetchUser = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
      if (response.data?.productor) {
        setFacturacion(response.data.facturacion)
        // Procesar archivos existentes
        const facturacionData = response.data.facturacion;

        ['comprobante_afip', 'comprobante_cbu', 'comprobante_entidad', 'comprobante_identificador'].forEach(field => {
          if (facturacionData?.[field]) {
            // Si el archivo viene codificado (ej: "liquidaciones/archivo.pdf")
            const fileName = facturacionData[field].split('/').pop();
            // Descargar y crear vista previa en caché
            fetchFilePreview(fileName, field);
          }
        });
      }
      if (response.data?.sala) {
        setFacturacion(response.data.facturacion)
        // Procesar archivos existentes
        const facturacionData = response.data.facturacion;

        ['comprobante_afip', 'comprobante_cbu', 'comprobante_entidad', 'comprobante_identificador'].forEach(field => {
          if (facturacionData?.[field]) {
            // Si el archivo viene codificado (ej: "liquidaciones/archivo.pdf")
            const fileName = facturacionData[field].split('/').pop();
            // Descargar y crear vista previa en caché
            fetchFilePreview(fileName, field);
          }
        });
      }
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!usuario && id) {
      fetchUser(setUsuario, {}, `/usuarios/${id}`);
    }
  }, [id]);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, `/provincias`);
    }
  }, []);

  // Cleanup de Object URLs al desmontar
  useEffect(() => {
    return () => {
      Object.values(filePreview).forEach(preview => {
        if (preview?.url && preview?.isExisting) {
          URL.revokeObjectURL(preview.url);
        }
      });
    };
  }, [filePreview]);

  if (!usuario || !provincias) {
    return "";
  }

  return (
    <Usuario
      data={usuario}
      facturacion={facturacion}
      provincias={provincias}
      onClick={onClick}
      onChange={onChange}
      filePreview={filePreview}
    />
  );
};

export default UsuarioController;
